import Types from './settings.types';

// Widget Settings
export const fetchWidgetSettingsStart = (id) => ({
  type: Types.FETCH_WIDGET_SETTINGS_START,
  payload: id,
});
export const postWidgetSettingsStart = (settings, prevData) => ({
  type: Types.POST_WIDGET_SETTINGS_START,
  payload: {
    data: settings,
    prevData: prevData,
  },
});

export const setWidgetAllSettings = (settings) => ({
  type: Types.SET_WIDGET_ALL_SETTINGS,
  payload: settings,
});
export const loadingWidgetAllSettings = (value) => ({
  type: Types.LOADING_WIDGET_ALL_SETTINGS,
  payload: value,
});
export const setWidgetIsSubmitting = (value) => ({
  type: Types.SET_WIDGET_SETTINGS_IS_SUBMITTING,
  payload: value,
});

export const setWidgetLanding = (data) => ({
  type: Types.SET_WIDGET_LANDING,
  payload: data,
});
export const setWidgetStyles = (data) => ({
  type: Types.SET_WIDGET_STYLES,
  payload: data,
});
export const setWidgetViewSettings = (data) => ({
  type: Types.SET_WIDGET_VIEW_SETTINGS,
  payload: data,
});
export const setWidgetDomains = (data) => ({
  type: Types.SET_DOMAINS,
  payload: data,
});
export const setWidgetPosition = (data) => ({
  type: Types.SET_POSITION,
  payload: data,
});

export const setAutoMessagesLoading = (loading) => ({
  type: Types.SET_AUTO_MESSAGES_LOADING,
  payload: loading,
});

export const fetchAllAutoMessages = (channelId) => ({
  type: Types.FETCH_AUTO_MESSAGES,
  payload: channelId,
});

export const setAutoMessages = (autoMessages) => ({
  type: Types.SET_AUTO_MESSAGES,
  payload: autoMessages,
});

export const setSelectedAutoMessage = (message, setPrevData = false) => ({
  type: Types.SET_SELECTED_AUTO_MESSAGE,
  payload: { data: message, setPrevData },
});

export const setSelectedAutoMessageErrors = (errors) => ({
  type: Types.SET_SELECTED_AUTO_MESSAGE_ERROR,
  payload: errors,
});

export const publishselectedAutoMessage = (data, setLoading) => ({
  type: Types.PUBLISH_SELECTED_AUTO_MESSAGE,
  payload: { data, setLoading },
});

export const editAutoMessage = (data, setLoading) => ({
  type: Types.EDIT_AUTO_MESSAGE,
  payload: { data, setLoading },
});

export const saveAutoMessageAndReturn = (history) => ({
  type: Types.SAVE_AUTO_MESSAGE_AND_RETURN,
  payload: history,
});

export const toggleAutoMessageStatus = (data) => ({
  type: Types.TOGGLE_AUTO_MESSAGE_STATUS,
  payload: data,
});

export const deleteAutoMessage = (
  messageId,
  channelId,
  setLoadingDelete,
  setConfirmModalVisible
) => ({
  type: Types.DELETE_AUTO_MESSAGE,
  payload: {
    messageId,
    channelId,
    setLoadingDelete,
    setConfirmModalVisible,
  },
});

export const determineSelectedAutoMessage = (payload) => ({
  type: Types.DETERMINE_SELECTED_AUTO_MESSAGE,
  payload,
});

export const addNewTimeWorkTimeSelection = (workTimeSelection) => ({
  type: Types.ADD_NEW_WORK_TIME_SELECTION,
  payload: workTimeSelection,
});

export const removeTimeWorkSelection = (id) => ({
  type: Types.REMOVE_WORK_TIME_SELECTION,
  payload: id,
});

export const saveOfficeHoursSettings = (payload) => ({
  type: Types.SAVE_OFFICE_HOURS_SETTINGS,
  payload,
});

export const setOfficeHoursSettings = (settings) => ({
  type: Types.SET_OFFICE_HOURS_SETTINGS,
  payload: settings,
});

export const setEmailSettings = (data) => ({
  type: Types.SET_EMAIL_SETTINGS,
  payload: data,
});

export const saveEmailSettings = (data) => ({
  type: Types.SAVE_EMAIL_SETTINGS,
  payload: data,
});

export const setGeneralSettings = (data) => ({
  type: Types.SET_GENERAL_SETTINGS,
  payload: data,
});

export const saveGeneralSettings = (data) => ({
  type: Types.SAVE_GENERAL_SETTINGS,
  payload: data,
});

export const fetchOfficeHoursSettings = (channelId) => ({
  type: Types.FETCH_OFFICE_HOURS_SETTINGS,
  payload: channelId,
});

export const fetchEmailSettings = (channelId) => ({
  type: Types.FETCH_EMAILS_SETTINGS,
  payload: channelId,
});

export const fetchGeneralSettings = (channelId) => ({
  type: Types.FETCH_GENERAL_SETTINGS,
  payload: channelId,
});

export const setPrevSettings = (data) => ({
  type: Types.SET_PREV_SETTINGS,
  payload: data,
});

export const resetSelectedMsgStateToInitial = () => ({
  type: Types.RESET_SELECTED_MSG_STATE_TO_INITIAL,
});

export const changeSender = (data, setLoading) => ({
  type: Types.CHANGE_MESSAGE_SENDER,
  payload: { data, setLoading },
});

// RESPONSE DELAY
export const getResponseDelayData = (channelId) => ({
  type: Types.GET_RESPONSE_DELAY_DATA,
  payload: channelId,
});

export const getResponseDelayDataSuccess = (data) => ({
  type: Types.GET_RESPONSE_DELAY_DATA_SUCCESS,
  payload: data,
});

export const getResponseDelayDataFailure = (error) => ({
  type: Types.GET_RESPONSE_DELAY_DATA_FAILURE,
  payload: error,
});

export const postResponseDelayData = (data) => ({
  type: Types.POST_RESPONSE_DELAY_DATA,
  payload: data,
});

export const postResponseDelayDataSuccess = (data) => ({
  type: Types.POST_RESPONSE_DELAY_DATA_SUCCESS,
  payload: data,
});

export const postResponseDelayDataFailure = (error) => ({
  type: Types.POST_RESPONSE_DELAY_DATA_FAILURE,
  payload: error,
});

export const putResponseDelayData = (channelId, data) => ({
  type: Types.PUT_RESPONSE_DELAY_DATA,
  payload: { channelId, data },
});

export const putResponseDelayDataSuccess = (data) => ({
  type: Types.PUT_RESPONSE_DELAY_DATA_SUCCESS,
  payload: data,
});

export const putResponseDelayDataFailure = (error) => ({
  type: Types.PUT_RESPONSE_DELAY_DATA_FAILURE,
  payload: error,
});

export const deleteResponseDelayData = ({ channelId, index }) => ({
  type: Types.DELETE_RESPONSE_DELAY_DATA,
  payload: { channelId, index },
});

export const deleteResponseDelayDataSuccess = (data) => ({
  type: Types.DELETE_RESPONSE_DELAY_DATA_SUCCESS,
  payload: data,
});

export const deleteResponseDelayDataFailure = (error) => ({
  type: Types.DELETE_RESPONSE_DELAY_DATA_FAILURE,
  payload: error,
});

// form generator
export const postFormGeneratorData = (data) => ({
  type: Types.FORM_GENERATOR_POST_DATA,
  payload: data,
});

export const postFormGeneratorDataSuccess = (data) => ({
  type: Types.FORM_GENERATOR_POST_DATA_SUCCESS,
  payload: data,
});

export const postFormGeneratorDataFailure = (error) => ({
  type: Types.FORM_GENERATOR_POST_DATA_FAILURE,
  payload: error,
});

// responsive robot
export const getResponsiveRobotData = (channelId) => ({
  type: Types.RESPONSIVE_ROBOT_GET_DATA,
  payload: channelId,
});

export const getResponsiveRobotDataSuccess = (data) => ({
  type: Types.RESPONSIVE_ROBOT_GET_DATA_SUCCESS,
  payload: data,
});

export const getResponsiveRobotDataFailure = (error) => ({
  type: Types.RESPONSIVE_ROBOT_GET_DATA_FAILURE,
  payload: error,
});

export const deleteResponsiveRobotData = ({ channelId, teamId }) => ({
  type: Types.RESPONSIVE_ROBOT_DELETE_DATA,
  payload: { channelId, teamId },
});

export const deleteResponsiveRobotDataSuccess = (data) => ({
  type: Types.RESPONSIVE_ROBOT_DELETE_DATA_SUCCESS,
  payload: data,
});

export const deleteResponsiveRobotDataFailure = (error) => ({
  type: Types.RESPONSIVE_ROBOT_DELETE_DATA_FAILURE,
  payload: error,
});

export const putResponsiveRobotData = (channelId, data) => ({
  type: Types.RESPONSIVE_ROBOT_PUT_DATA,
  payload: { channelId, data },
});

export const putResponsiveRobotDataSuccess = (data) => ({
  type: Types.RESPONSIVE_ROBOT_PUT_DATA_SUCCESS,
  payload: data,
});

export const putResponsiveRobotDataFailure = (error) => ({
  type: Types.RESPONSIVE_ROBOT_PUT_DATA_FAILURE,
  payload: error,
});

export const postResponsiveRobotData = ({ data, setLoadingSubmit }) => ({
  type: Types.RESPONSIVE_ROBOT_POST_DATA,
  payload: { data, setLoadingSubmit },
});

export const changeAiBotEnabledStatus = ({
  status,
  connectAgent,
  setLoadingSwitch,
}) => ({
  type: Types.CHANGE_AI_BOT_ENABLED_STATUS,
  payload: { status, connectAgent, setLoadingSwitch },
});

export const setAiBotStatus = (status) => ({
  type: Types.SET_AI_BOT_STATUS,
  payload: status,
});

export const fetchAiChatBotStatus = (channelId) => ({
  type: Types.FETCH_AI_BOT_SETTINGS,
  payload: channelId,
});
